import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { ReportListing } from '@app/components/eMIPs/Reports/ReportListing';

export const ListReportsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>{t('reports.title')}</PageTitle>
      <ReportListing />
    </>
  );
};
